import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ProductCardTileIdsAndIcons = styled.div`
    display: grid;
    gap: ${SPACING.SMALL_3};
    grid-template-columns: auto auto;
    align-items: center;
`;

export const HorizontalLine = styled.div`
    height: 1px;
    background: ${Colors.gray30};
`;

export const SpacerHorizontalLine = styled(HorizontalLine)`
    margin-bottom: auto;
    background: transparent;

    &.ab-scalable-product-card-spacer-showLine {
        background: ${Colors.gray30};
    }
`;
